module.exports = __webpack_public_path__ + "static/media/nynfc8.1c8b1671.jpg";